import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class COEBidsDetailsReportService {
  constructor(private http: HttpUtilService) {}

  COEBidsDetailsReport(
    BidDate: string,
    BidType: string,
  ): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/COEBidsDetailsReport`,
      {
        BidDate,
        BidType,
      },
    );
  }
}
